import { toDisplayDateFormat } from 'lib/utils';
import { DateObj } from 'dayzed';
import { startOfDay } from 'date-fns';
import isUndefined from 'lodash/isUndefined';
import { ValuesRef } from '../types';
import { getVariant } from './getVariant';
import { getNewDates } from './getNewDates';
import { handleDraftApply } from './handleDraftApply';

export function getContainerProps(values: ValuesRef) {
  return { ref: values.current.container };
}

export function getInputProps(values: ValuesRef) {
  const { isOpen, setIsOpen, draftDates, setDraftDates, inputContainer } = values.current;

  const startDateDisplayValue = draftDates.startDate ? toDisplayDateFormat(draftDates.startDate) : '';
  const endDateDisplayValue = draftDates.endDate ? toDisplayDateFormat(draftDates.endDate) : '';

  const startDateFocused = (isOpen && isUndefined(draftDates.startDate)) || false;
  const endDateFocused = (isOpen && !isUndefined(draftDates.startDate)) || false;

  const onStartDateFocus = () => {
    setDraftDates({ startDate: undefined, endDate: undefined });
    setIsOpen(true);
  };

  const onEndDateFocus = () => setIsOpen(true);

  return {
    ref: inputContainer,
    readOnly: true,
    onStartDateFocus,
    onEndDateFocus,
    startDatePlaceholder: 'Check-in',
    endDatePlaceholder: 'Check-out',
    startDateDisplayValue,
    endDateDisplayValue,
    startDateFocused,
    endDateFocused,
  };
}

export function getDoneProps(values: ValuesRef) {
  return { onClick: () => handleDraftApply(values) };
}

export function getCancelProps(values: ValuesRef) {
  return { onClick: () => values.current.setIsOpen(false) };
}

export function getPopperProps(values: ValuesRef) {
  const { isSmall, popperProps } = values.current;
  const calendarContainerProps = isSmall ? { style: popperProps.styles.popper, ...popperProps.attributes.popper } : {};

  return {
    ref: values.current.pickerContainer,
    ...calendarContainerProps,
  };
}

export function getMonthProps(values: ValuesRef) {
  return { onMouseLeave: () => values.current.setHoveredDate(undefined) };
}

export function getDateProps(values: ValuesRef, dateObj: DateObj) {
  const { dayzedProps } = values.current;
  const dayzedDateProps = dayzedProps.getDateProps({ dateObj });

  const variant = getVariant(values, dateObj);
  const disabled = variant === 'blocked' || variant === 'disabled' ? true : dayzedDateProps.disabled;

  return {
    ...dayzedDateProps,
    disabled,
    [`data-variant`]: variant,
    onMouseEnter: () => values.current.setHoveredDate(startOfDay(dateObj.date)),
  };
}

export function handleDateSelected(values: ValuesRef, selectedDateObj: DateObj) {
  values.current.setDraftDates(getNewDates(values, selectedDateObj));
}
